var formDef = {
    resid: [{
        title: 'Meno',
        name: 'fName',
        help: null,
        value: '',
        isErr: false
    },
    {
        title: 'Priezvisko',
        name: 'surName',
        help: null,
        value: '',
        isErr: false
    },
    {
        title: 'Rodné číslo',
        name: 'personalId',
        help: 'Rodné číslo bez lomítka a bez medzier',
        value: '',
        isErr: false
    }
],
    business: [{
        title: 'Meno',
        name: 'fName',
        help: 'Meno osoby, ktorú máte na zmluve uvedenú ako primárny kontakt',
        value: '',
        isErr: false
    },
    {
        title: 'Priezvisko',
        name: 'surName',
        help: 'Priezvisko osoby, ktorú máte na zmluve uvedenú ako primárny kontakt',
        value: '',
        isErr: false
    },
    {
        title: 'IČO',
        name: 'companyReg',
        help: 'Identifikačné číslo spoločnosti podľa Obchodného registra SR, resp. Živnostenského registra SR',
        value: '',
        isErr: false
    }]
}

module.exports = formDef;